import { CONSTANT, FEE_TYPE, STRING_CONSTANT } from "../constants/constants";
import { properties } from "../constants/properties";
import { parseISO, isEqual, isValid } from "date-fns";

export const formatFromToDate = (dateFromString, dateToString) => {
  const formattedDateFrom = formatDate(dateFromString);
  const formattedDateTo = formatDate(dateToString);
  const dates = [formattedDateFrom, formattedDateTo].filter(Boolean);
  return dates.join(" - ") || STRING_CONSTANT.BLANK;
};

export const getFormattedDateRange = (dateFromString, dateToString) => {
  if (!dateFromString && !dateToString) return STRING_CONSTANT.BLANK;

  const from = parseISO(dateFromString);
  const to = parseISO(dateToString);
  const formattedDateFrom = isValid(from) ? formatDate(from) : "";
  const formattedDateTo = isValid(to) ? formatDate(to) : "";

  // 👉 New condition: if both dates are valid and equal, return only one
  if (isValid(from) && isValid(to) && isEqual(from, to)) {
    return formattedDateFrom;
  }
  const dates = [formattedDateFrom, formattedDateTo].filter(Boolean);
  return dates.join(" - ") || STRING_CONSTANT.BLANK;
};

export const calculateTotal = (regFees, optFees, tax, authorPaperFees) =>{
  return (regFees + optFees) * (1 + tax) + authorPaperFees;
}

export const formatDate = (dateString) => {
  if (dateString) {
    const date = new Date(dateString);
    let month = date.getMonth() + 1;
    if (month < 10) {
      month = `0${month}`;
    }
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }
};

export const getLocation = (street, city, country) => {
  const locationParts = [];

  if (street) {
    locationParts.push(street);
  }
  if (city) {
    locationParts.push(city);
  }
  if (country) {
    locationParts.push(country);
  }
  return locationParts.length > 0
    ? locationParts.join(", ")
    : STRING_CONSTANT.BLANK;
};

export const getFeesList = (list, status, isPaid) => {
  if (list?.length > 0) {
    if (!status) {
      return list.filter((item) => item.isMandatory === false);
    }
    if (isPaid) {
      return list.filter(
        (item) =>
          item.isMandatory === true &&
          item.discount !== "100" &&
          item.regularFeeAED !== 0
      );
    } else {
      return list.filter(
        (item) =>
          item.isMandatory === true &&
          (item.discount === "100" || item.regularFeeAED === 0)
      );
    }
  } else {
    return [];
  }
};

export const calculateOptFeePayment = (
  optionalRegistrationValue,
  conferenceFeesList,
  conferenceDetails,
  tax
) => {
  let conferenceFee = findConferenceFee(
    conferenceFeesList,
    optionalRegistrationValue
  );
  if (conferenceFee) {
    return getFeePayment(conferenceDetails, conferenceFee, tax);
  }
  return null;
};
export const resetOptionalRegistrationFields =(conferenceFeesList,setFieldValue) =>{
  setFieldValue(CONSTANT.OPTIONAL_SUBSCRIPTION_RADIO,STRING_CONSTANT.BLANK);
  setFieldValue("optionalRegistration" , []);
  setFieldValue("membershipNumber" , STRING_CONSTANT.BLANK);
  conferenceFeesList?.items?.forEach((fee, index) => {
    setFieldValue(fee?.subscriptionKey, false);
  });
}

export const findConferenceFee = (conferenceFeesList, subscriptionKey) => {
  if (conferenceFeesList?.items) {
    const conferenceFee = conferenceFeesList.items.find(
      (item) => item.subscriptionKey === subscriptionKey
    );
    return conferenceFee;
  }
  return null;
};

export const getFeePayment = (
  conferenceDetails,
  conferenceFeeObject,
  tax,
  feeType
) => {
  if (conferenceFeeObject) {
    let feePecentageAfterDiscount = 100;
    if (conferenceFeeObject.discount) {
      feePecentageAfterDiscount =
        feePecentageAfterDiscount - Number(conferenceFeeObject.discount);
    }

    let fee;
    if (feeType === FEE_TYPE.REGISTRATION) {
      fee = compareDate(conferenceDetails?.earlyBirdCutoffDate)
        ? conferenceFeeObject.earlyBirdFeeAED
        : conferenceFeeObject.regularFeeAED;
    } else {
      fee = conferenceFeeObject.regularFeeAED;
    }
    if (fee) {
      return (fee * (feePecentageAfterDiscount / 100)) / (1 + tax);
    }
  }
  return 0;
};

const compareDate = (dateString) => {
  if (dateString) {
    const date = new Date(dateString);
    let currentDate = new Date();
    return currentDate < date;
  }
  return false;
};

export const isConfrenceEnded = (inputStringDate) => {
  if (inputStringDate) {
    const date = new Date(inputStringDate);
    const currentDate = new Date();

    date.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    return currentDate <= date;
  }
};

export const prepareRegistrationPayload = (
  formData,
  id,
  isFreeRegistration
) => {
  const registration = {
    title: formData.title,
    firstName: formData.firstName,
    lastName: formData.lastName,
    userEmail: formData.userEmail,
    mobile: formData.mobile,
    country: formData.country,
    affiliation: formData.affiliation,
    registrationType: formData.registrationType,
    authorRegistering: false,
    membershipNumber: formData.membershipNumber,
    optionalRegistration: formData.optionalRegistration,
    isAuthor: formData.isAuthor,
    noOfPapers: formData.noOfPapers,
    paperReferences: formData.paperReferences,
    total: formData.total,
    registrationDate: new Date(),
    companyId: properties.companyId,
    userId: properties.userId,
    groupId: properties.siteGroupId,
    countryCode: formData.countryCode,
    conferenceId: id,
    isFreeRegistration: isFreeRegistration,
  };

  return registration;
};
